import { Inject, Injectable } from '@angular/core';
import { isNil } from 'lodash-es';
import { environment } from '../environments/environment';

import { UtilsService } from './utils.service';
import { SettingsValuesService } from './settings.values.service';

@Injectable({ providedIn: 'root' })
export class Returns_ds_outbound_orders_eligible_for_return_gridService {

  constructor(
    private $utils: UtilsService,
    private $settings: SettingsValuesService,
    ) { 
  }

  public async get(inParams: { warehouseIds?: number[], ownerId?: number, projectId?: number, dateFrom?: string, dateTo?: string, dateType?: string, fullTextSearch?: string }): 
  Promise<{ result: { Id?: number, CreatedSysDateTime?: string, FulfillmentDate?: string, LookupCode?: string, Notes?: string, OwnerReference?: string, RequestedDeliveryDate?: string, VendorReference?: string, Project?: { Name?: string, Owner?: { Name?: string } }, OrderClass?: { Name?: string }, ShipmentOrderLookups?: { ShipmentId?: number, Shipment?: { LookupCode?: string, ActualWarehouse?: { Name?: string }, Carrier?: { Name?: string }, CarrierServiceType?: { Name?: string } } }[] }[] }> 
  {
    let url = `${environment.backendUrl}api/Returns/datasources/ds_outbound_orders_eligible_for_return_grid/get`;
    
    const options = {
    }
    
    const body = inParams;
    
    return this.$utils.http.post(url, body, options);
    
  }
  public async getList(inParams: { warehouseIds?: number[], ownerId?: number, projectId?: number, dateFrom?: string, dateTo?: string, dateType?: string, fullTextSearch?: string, $top?: number, $skip?: number }): 
  Promise<{ result: { Id?: number, CreatedSysDateTime?: string, FulfillmentDate?: string, LookupCode?: string, Notes?: string, OwnerReference?: string, RequestedDeliveryDate?: string, VendorReference?: string, Project?: { Name?: string, Owner?: { Name?: string } }, OrderClass?: { Name?: string }, ShipmentOrderLookups?: { ShipmentId?: number, Shipment?: { LookupCode?: string, ActualWarehouse?: { Name?: string }, Carrier?: { Name?: string }, CarrierServiceType?: { Name?: string } } }[] }[], totalCount: number }> 
  {
    let url = `${environment.backendUrl}api/Returns/datasources/ds_outbound_orders_eligible_for_return_grid/getList`;
    
    const options = {
    }
    
    const body = inParams;
    
    return this.$utils.http.post(url, body, options);
    
  }
  public async getByKeys(inParams: { warehouseIds?: number[], ownerId?: number, projectId?: number, dateFrom?: string, dateTo?: string, dateType?: string, fullTextSearch?: string, $keys: number[] }): 
  Promise<{ result: { Id?: number, CreatedSysDateTime?: string, FulfillmentDate?: string, LookupCode?: string, Notes?: string, OwnerReference?: string, RequestedDeliveryDate?: string, VendorReference?: string, Project?: { Name?: string, Owner?: { Name?: string } }, OrderClass?: { Name?: string }, ShipmentOrderLookups?: { ShipmentId?: number, Shipment?: { LookupCode?: string, ActualWarehouse?: { Name?: string }, Carrier?: { Name?: string }, CarrierServiceType?: { Name?: string } } }[] }[] }> 
  {
    const missingRequiredInParams = [];
    if (isNil(inParams.$keys)) {
      missingRequiredInParams.push('\'$keys\'');
    }
    if (missingRequiredInParams.length) {
    }
    let url = `${environment.backendUrl}api/Returns/datasources/ds_outbound_orders_eligible_for_return_grid/getByKeys`;
    
    const options = {
    }
    
    const body = inParams;
    
    return this.$utils.http.post(url, body, options);
    
  }


    
    hasMissingRequiredInParams(inParams: { 
      warehouseIds?: number[], ownerId?: number, projectId?: number, dateFrom?: string, dateTo?: string, dateType?: string, fullTextSearch?: string    }) {
      return false;
    }
}
